export class State {
    id:string;
    name:string;

    constructor(other?:State) {
        if (other) {
            this.name = other.name;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/state.ts
 **/